import { joinInfoMeta } from './joinMetaInfo.js';
import { mergeMetadata } from './mergeMetadata';
import { parseData } from './parseData';
import { setFIDSpectrumData } from './setFIDSpectrumData';
import { setProcessedSpectrumData } from './setProcessedSpectrumData';

export async function convert2D(files, options) {
  const data = {};
  const promises = [];
  const filesToRead = ['2rr', '2ri', '2ir', '2ii', 'ser'];
  for (const key of filesToRead) {
    if (!files[key]) continue;
    promises.push(files[key].arrayBuffer().then((r) => (data[key] = r)));
  }
  promises.push(parseData(files.procs, options).then((r) => (data.procs = r)));
  promises.push(
    parseData(files.proc2s, options).then((r) => (data.proc2s = r)),
  );
  promises.push(parseData(files.acqus, options).then((r) => (data.acqus = r)));
  promises.push(
    parseData(files.acqu2s, options).then((r) => (data.acqu2s = r)),
  );
  await Promise.allSettled(promises);
  return formatSpectrum(data);
}

function formatSpectrum(data) {
  const result = mergeMetadata(data.procs, data.proc2s);
  const acqus = mergeMetadata(data.acqus, data.acqu2s);

  joinInfoMeta(result, acqus);

  if (!result.meta.SW_p) {
    // eslint-disable-next-line camelcase
    result.meta.SW_p = result.meta.SW_h;
  }
  if (!result.meta.SF) {
    result.meta.SF = result.meta.SFO1;
  }

  const isFft = ['2rr', '2ri', '2ir', '2ii'].some((key) => key in data);
  result.meta.nbSubSpectra = isFft
    ? parseInt(result.meta.SI[1], 10)
    : parseInt(result.meta.TD[1], 10);

  let firstY, lastY, xOffset, yOffset;
  if (isFft) {
    let sf = Number(result.meta.SF[1]);
    let swP = Number(result.meta.SW_p[1] || result.meta.SW[1]);
    yOffset = Number(result.meta.OFFSET[1]);
    xOffset = Number(result.meta.OFFSET[0]);
    firstY = yOffset;
    lastY = yOffset - swP / sf;
    result.meta.firstY = firstY;
    result.meta.lastY = lastY;
    setProcessedSpectrumData(
      {
        rr: data['2rr'],
        ri: data['2ri'],
        ir: data['2ir'],
        ii: data['2ii'],
      },
      result,
    );
  } else if (data.ser) {
    firstY = 0;
    lastY = result.meta.nbSubSpectra;
    let xWindowSize = Number(result.meta.SW[0]);
    let yWindowSize = Number(result.meta.SW[1]);
    let xTransmitterFrequency = Number(result.meta.SFO1[0]);
    let yTransmitterFrequency = Number(result.meta.SFO1[1]);
    let xTransmitterFrequencyOffset = Number(result.meta.O1[0]);
    let yTransmitterFrequencyOffset = Number(result.meta.O1[1]);
    xOffset =
      xTransmitterFrequencyOffset / xTransmitterFrequency + xWindowSize / 2;
    yOffset =
      yTransmitterFrequencyOffset / yTransmitterFrequency + yWindowSize / 2;
    setFIDSpectrumData(data.ser, result, true);
  }

  let pageValue = firstY;
  let nbSubSpectra = result.meta.nbSubSpectra / (isFft ? 1 : 2);
  let deltaY = (lastY - firstY) / (nbSubSpectra - 1);
  for (let i = 0; i < nbSubSpectra; i++) {
    pageValue += deltaY;
    result.spectra[i].pageValue = pageValue;
  }
  let { NUC1: nuc1, AXNUC: axnuc, SF: sf } = result.meta;
  const nucleus = axnuc ? axnuc : nuc1 ? nuc1 : [];
  result.info['2D_Y_NUCLEUS'] = nucleus[1];
  result.info['2D_X_NUCLEUS'] = nucleus[0];
  result.info['2D_Y_FRECUENCY'] = sf[1];
  result.info['2D_X_FRECUENCY'] = sf[0];
  result.info['2D_Y_OFFSET'] = yOffset;
  result.info['2D_X_OFFSET'] = xOffset;
  result.info.twoD = true;
  result.twoD = true;

  return result;
}
